// extracted by mini-css-extract-plugin
export default {"wrapper":"NoResults_wrapper__c3SBh"};